import { email, required } from "ra-core";
import { ReferenceInput } from "@/components/admin/reference-input";
import { TextInput } from "@/components/admin/text-input";

import { AutocompleteCompanyInput } from "../companies/AutocompleteCompanyInput.tsx";

export const ContactInputs = () => {
  return (
    <div className="flex flex-col gap-4 p-1">
      <TextInput source="first_name" validate={required()} helperText={false} />
      <TextInput source="last_name" helperText={false} />
      <ReferenceInput source="company_id" reference="companies" perPage={10}>
        <AutocompleteCompanyInput
          label="resources.contacts.fields.company_id"
          validate={required()}
        />
      </ReferenceInput>
      <TextInput
        source="email"
        type="email"
        validate={email()}
        helperText={false}
      />
    </div>
  );
};
